


<template lang="jade">

	div.credits(
		v-if="$route.name !== 'trailer' && credits"
		v-html="credits"
	)

</template>



<script>



	const $cmp = {
		name : 'credits',
		components : {}
	}



	$cmp.data = function() {
		return {}
	}



	$cmp.computed = {}

	$cmp.computed.credits = function() {
		let $this = this
		return $this.$store.credits
	}



	$cmp.mounted = function() {
		var $this = this
	}



	$cmp.methods = {}



	export default $cmp



</script>



<style lang="stylus" scoped>

	.credits
		position absolute
		width 100%
		max-width 600px
		top 230px
		left 50%
		transform translate(-50%,0px)
		color #FFFFFF
		font-size 10px
		letter-spacing 1px
		text-transform uppercase
		text-align center
		z-index 3

		@media(max-width 1023px)
			display none


</style>



// WEBPACK FOOTER //
// src/components/home/credits.vue